import React, {useState} from 'react';
import './App.css';
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import {notification} from "antd";
import Privacy from "./Components/Privacy/Privacy";
import {routes} from "./Constants/Constants";
import Login from "./Components/Login/Login";
import Home from "./Components/Home/Home";
import {useDispatch, useSelector} from "react-redux";
import {authSuccess} from "./Core/Actions/Auth";
import PublicRoutes from "./Constants/Routes/PublicRoutes";
import PrivateRoutes from "./Constants/Routes/PrivateRoutes";
import NotFound from "./Components/NotFound/NotFound";


function App() {


    const dispatch = useDispatch();
    if (navigator.cookieEnabled) {

        const auth = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        const image = localStorage.getItem('image');

        if (auth !== null) {
            dispatch(authSuccess(user, true, image));

        }

    }

    return (
        <BrowserRouter>
            <Switch>
                <Route path={routes.App.Privacy}>
                    <Privacy/>
                </Route>
                <PublicRoutes exact path={routes.App.Login}>
                    <Login/>
                </PublicRoutes>
                <PrivateRoutes path={routes.App.Home}>
                    <Home/>
                </PrivateRoutes>
                <Route path="*">
                    <NotFound/>
                </Route>

            </Switch>
        </BrowserRouter>

    );
}

export default App;
